import { render, staticRenderFns } from "./seatBindingDetails.vue?vue&type=template&id=1fd49f6c&"
import script from "./seatBindingDetails.vue?vue&type=script&lang=js&"
export * from "./seatBindingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports